import {
  signIn as cognitoSignIn,
  confirmSignIn,
  signOut as cognitoSignOut,
} from "aws-amplify/auth";
import { useCallback } from "react";

import { UseAuthReturnType } from "./types";

export const useAuth = (): UseAuthReturnType => {
  const signIn = useCallback(async (phoneNumber: string) => {
    // reset any lingering custom-auth flow state before starting a new one
    await cognitoSignOut({ global: true });

    const { nextStep } = await cognitoSignIn({
      username: phoneNumber,
      options: { authFlowType: "CUSTOM_WITHOUT_SRP" },
    });

    // v5's CognitoUser.challengeParam is surfaced as nextStep.additionalInfo in v6
    return nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
      ? nextStep.additionalInfo
      : undefined;
  }, []);

  const answerChallenge = useCallback(async (answer: string) => {
    await confirmSignIn({ challengeResponse: answer });
  }, []);

  const signOut = useCallback(async () => {
    await cognitoSignOut();
  }, []);

  return { signIn, answerChallenge, signOut };
};
